if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);

      const cartDrawerContainer = this.closest('cart-drawer');
      const cartPageFormContainer = this.closest('.cart.form');

      if (cartDrawerContainer) {
        const checkoutButton = cartDrawerContainer.querySelector('button[name="checkout"]');

        if (checkoutButton) {
          checkoutButton.addEventListener('click', this.submitHandler);
        }

      }
      if (cartPageFormContainer) {
        const checkoutButton = cartPageFormContainer.querySelector('button[name="checkout"]');

        if (checkoutButton) {
          checkoutButton.addEventListener('click', this.submitHandler);
        }
      }

      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      
      if (!document.querySelector('.js-cart-terms-checkbox').checked) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
